import { faBank, faPeopleArrows } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Payments() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const transferOptions = [
    {
      title: t("EALBANIA_PAYMENTS"),
      icon: `images/E-Albania.svg`,
      imgIcon: true,
      action: () => {
        navigate("/payments/ealbania");
      },
    },
    {
      title: t("SMARTFIN_PAYMENTS"),
      icon: `images/smartfin.png`,
      imgIcon: true,
      action: () => {
        navigate("/payments/smartfin");
      },
    },
    {
      title: t("LOAN"),
      icon: faBank,
      action: () => {
        //navigate("/payments/loans");
      },
    },
    {
      title: t("SPLIT_BILL_PAYMENTS"),
      icon: faPeopleArrows,
      action: () => {
        //navigate("/transfer-qr-code");
      },
    },
  ];

  return (
    <>
      <Toolbar title={t("PAYMENTS")} showBackBtn={true} />
      <div>
        <div className="flex w-full justify-center">
          <div className="container grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5 mx-7">
            {transferOptions.map((it) => (
              <div className="col-span-1 bg-card text-white p-4 flex flex-col items-center justify-center cursor-pointer h-[10rem]" onClick={it.action}>
                {it.imgIcon ? <img src={it.icon} className="w-12 h-12" alt="" /> : <FontAwesomeIcon icon={it.icon} className="card-icon pt-5" size={"2xl"} />}
                <h4 className="font-medium pb-5 pt-2 text-center">{it.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Payments;
